/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */
/**
 *  @param {boolean} restart 重新启动
 */
export default class Tool {

  /**
   * 
   * @param options 
   */
  setOptions(options) {
    T.assign(this.options, options);
  }
  /**
   * 
   */
  reback() {
    let { marker, layer, history } = this;
    if (marker) {
      if (marker._defaultShape) {//线/面
        let latlngs = marker._defaultShape();
        let latlng = latlngs.pop();
        if (latlng) {
          history.push(latlng);
          marker.setLatLngs(latlngs);
        } else {
          marker.removeFrom(layer);
          return true;
        }
      } else {
        marker.removeFrom(layer);
        return true;
      }
    }
  }
  /**
   * 
   */
  restore() {
    let { marker, layer, history } = this;
    if (marker) {
      marker.addTo(layer);
      //
      if (marker._defaultShape && history.length > 0) {//线/面
        let latlngs = marker._defaultShape();
        let latlng = history.pop();
        latlngs.push(latlng);
        marker.setLatLngs(latlngs);
      } else {
        return true;
      }
    }
  }
  /**
   * 绘制结束
   * @param e 
   */
  onEnd(e) {
    //
    this.history = [];
    //
    this.dmap.do('draw-end', { target: this, marker: this.marker });
  }
  /**
   * 清除图元，用于重置工具，重复绘制，或者取消绘制
   */
  clear() {
    let { marker } = this;
    marker && marker.remove();
  }
  /**
   * 重置
   */
  reset() {
    if (this.restart) {
      this.clear();
      this.restart = false;
      this.marker = null;
    }
  }
  /**
   * 
   */
  cancel() {

  }
  /**
   * 创建
   * @param control 
   */
  static create(owner, options) {
    let tool = new this();
    tool.owner = owner;
    tool.dmap = owner.dmap;
    tool.map = owner.map;
    tool.layer = owner.layer;
    tool.setOptions(options)
    return tool;
  }
  /**
   * 复制工具
   */
  clone() {
    return this.constructor.create(this.owner, this.options)
  }
}


// WEBPACK FOOTER //
// ./src/plugins/tools/Tool.js